
    import './styles.scoped.css';
    export default {
  "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_qwoo0_111rm_5",
  "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_qwoo0_111rm_1",
  "refresh": "awsui_refresh_qwoo0_111rm_26",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_qwoo0_111rm_1",
  "root": "awsui_root_qwoo0_111rm_51",
  "interior": "awsui_interior_qwoo0_111rm_62",
  "dropdown": "awsui_dropdown_qwoo0_111rm_5",
  "use-portal": "awsui_use-portal_qwoo0_111rm_73",
  "dropdown-drop-up": "awsui_dropdown-drop-up_qwoo0_111rm_118",
  "with-limited-width": "awsui_with-limited-width_qwoo0_111rm_122",
  "dropdown-drop-left": "awsui_dropdown-drop-left_qwoo0_111rm_125",
  "dropdown-drop-right": "awsui_dropdown-drop-right_qwoo0_111rm_128",
  "occupy-entire-width": "awsui_occupy-entire-width_qwoo0_111rm_131",
  "hide-upper-border": "awsui_hide-upper-border_qwoo0_111rm_134",
  "open": "awsui_open_qwoo0_111rm_141",
  "nowrap": "awsui_nowrap_qwoo0_111rm_150",
  "is-empty": "awsui_is-empty_qwoo0_111rm_154",
  "dropdown-content": "awsui_dropdown-content_qwoo0_111rm_5",
  "ie11-wrapper": "awsui_ie11-wrapper_qwoo0_111rm_164",
  "stretch-trigger-height": "awsui_stretch-trigger-height_qwoo0_111rm_168"
};
  